<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->


<div class="page-with-right-panel">
  <div class="page-content">
    <div class="left">
      <ng-content select="[template=left]"></ng-content>
      <div class="spacer-if-floating-button-present"></div>
      <div class="floating-button">

        <p-button styleClass="p-button-rounded" (click)="onShowButton($event)" data-testid="on-show-button-btn">
          <i class="{{icon}} float-icon"></i>
        </p-button>

      </div>
    </div>


    <div class="right" [ngClass]="{'show': showPanelForMobile}">
      <ng-content select="[template=right]"></ng-content>
    </div>

  </div>

  <div class="overlay" [ngClass]="{'show': showPanelForMobile}" (click)="onHideButton($event)"></div>


</div>
